<template>
  <b-modal
    id="modal-menuset-footer"
    scrollable
    size="lg"
    no-close-on-backdrop
    no-close-on-esc
  >
    <template #modal-header>
      <div
        class="d-flex justify-content-between w-100 align-items-center"
      >
        <div class="w-100 d-flex align-items-center">
          <div @click="back"  style="font-size: 16px; color: #53585D;">
            <i class="fal fa-arrow-left cursor-pointer mr-gd-1"></i>
          </div>
           <TitleModal :label="`${action == 'add' ? $t('engine.manageFooter.manu.lblAddMenuSet', languageEngine) : $t('engine.manageFooter.manu.lblEditMenuSet', languageEngine)}`" />
        </div>
      </div>

      <div class="d-flex align-items-center">
        <div class="close mr-0 pr-10" type="button" style="font-size: 16px">
           <i class="fal fa-question-circle"></i>
        </div>
        <div
          @click="back"
          type="button"
          aria-label="Close"
          id="close-modal-menuset-footer"
          class="close-modal"
        >
          <i class="fal fa-times"></i>
        </div>
      </div>
    </template>
    <template>
      <b-row class="mb-20">
        <b-col sm="3">
          <label for="page-name" style="padding-top: 7px"
            ><span style="font-weight: 600"> {{$t("engine.manageFooter.menu.set.lblName",languageEngine)}} </span> {{ " "
            }}<span class="text-muted"
              >({{ languageUse && languageUse.toUpperCase() }})</span
            >
            <span class="text-danger ml-3">*</span>
            </label
          >
        </b-col>
        <b-col sm="9" :class="{ errors: $v.data.properties.name.$error }">
          <b-form-input
            v-model="$v.data.properties.name.$model"
            id="menu-set-footer-name"
            :placeholder="$t('engine.manageFooter.menu.set.lblName',languageEngine)"
          ></b-form-input>
          <small
            v-if="
              !$v.data.properties.name.required &&
              $v.data.properties.name.$error
            "
          >
            {{$t("engine.manageFooter.menu.set.validate.lblName",languageEngine)}}
          </small>
          <small
            v-if="
              !$v.data.properties.name.maxLength &&
              $v.data.properties.name.$error
            "
          >
            {{$t("engine.manageFooter.menu.set.validate.lblLongerName",languageEngine)}}
          </small>
          <!-- <small
            v-if="
              !$v.data.properties.name.alphaName &&
              $v.data.properties.name.$error
            "
          >
            {{$t("engine.manageFooter.menu.set.validate.lblAlphabetName",languageEngine)}}
          </small> -->
        </b-col>
      </b-row>
    </template>
    <template #modal-footer>
      <b-button variant="blue" class="mr-2" @click="save($event)">
        <i class="far fa-check"></i>   {{$t("engine.manageFooter.menu.set.lblSave",languageEngine)}}
      </b-button>
      <b-button variant="light" @click="back()">
        <i class="far fa-times"></i> {{$t("engine.manageFooter.menu.set.lblCancel",languageEngine)}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { capitalize } from "@helpers/text.helper";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";

import { required, maxLength } from "vuelidate/lib/validators";

const initMenuSetData = {
  type: "FOOTER_MENU_SET",
  id: "",
  version: "1",
  properties: {
    name: "",
    isEnable: true,
  },
  componentsID: [],
};

export default {
  data() {
    return {
      data: this.getData(),
    };
  },
  computed: {
    ...mapGetters({
      languageUse: "design/site/languageUse",
      languageEngine: "design/userPreference/languageEngine",
      siteComponents: "design/metadata/siteComponents",

    }),
  },
  components:{
    TitleModal,
  },
  watch: {
    action() {
      this.data = this.getData();
    },
  },
  methods: {
    capitalize,
    getData() {
      let data_temp = { ...JSON.parse(JSON.stringify(initMenuSetData)) };
      if (this.action && this.action !== "add") {
        data_temp = {
          ...JSON.parse(JSON.stringify(this.siteComponents[this.id])),
        };
      }
      return data_temp;
    },
    back() {
      this.$v.$reset();
      this.$bvModal.hide("modal-menuset-footer");
      this.$emit("clear");
    },
    genCharacters(length) {
      var result = [];
      var characters = "abcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result.push(
          characters.charAt(Math.floor(Math.random() * charactersLength))
        );
      }
      return result.join("");
    },
    genId() {
      var gen = "fms" + this.genCharacters(4);
      const index = Object.keys(this.siteComponents).findIndex((i) => i == gen);
      if (index !== -1) gen = this.genId();
      return gen;
    },
    save(evt) {
      delete this.data.show;
      this.$v.$touch();
      if (this.$v.$invalid) {
        evt.preventDefault();
        return;
      }
      let idForEmitMenuSetActive = undefined;
      if (this.action === "add") {
        const id = this.genId();
        const obj = {
          [id]: { ...JSON.parse(JSON.stringify(this.data)), id: id },
        };
        Object.assign(this.siteComponents, JSON.parse(JSON.stringify(obj)));
        this.siteComponents.FOOTER_WIDGET_MENU.componentsID.push(id);
        idForEmitMenuSetActive = id
      } else {
        this.siteComponents[this.id] = JSON.parse(JSON.stringify(this.data));
        idForEmitMenuSetActive = this.id
      }
      this.$store.dispatch("design/snapshot/genSnapshot", { type: "menu_set" });
      this.$toast.success({ title: this.$t("engine.common.alert.success.title", this.languageEngine), message: this.$t(`engine.manageFooter.menu.alert.msg${capitalize(this.action)}MenuSetSuccess`,this.languageEngine) });
      this.$emit("setMenuSetActive", idForEmitMenuSetActive);
      this.back();
    },
  },
  props: {
    action: {
      type: String,
    },
    id: {
      type: String,
      required: true,
    },
  },
  validations: {
    data: {
      properties: {
        name: {
          required,
          maxLength: maxLength(50),
        },
      },
    },
  },
};
</script>

<style></style>
